import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';

import { Button } from 'components/Button';
import { Content } from 'components/Content';
import { Grid } from 'components/Grid';
import { Heading, HeadingBoundary } from 'components/Heading';
import { cx } from 'utility';
import * as styles from './HeadingContent.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    title: PropTypes.string,
};

const defaultProps = {
    className: '',
    content: [],
    title: '',
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['headingContent'],
    );

    return classes || undefined;
}

function HeadingContent({
    className,
    content,
    title,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <Grid>
                <InView threshold={0.1} triggerOnce={true}>
                    {({ inView, ref, entry }) => {
                        return (
                            <div className={cx(styles['titleContainer'], (inView) && styles['inview'])} ref={ref}>
                                <HeadingBoundary>
                                    {title && (
                                        <Heading
                                            className={styles['title']}
                                            size={8}
                                        >
                                            {title}
                                        </Heading>
                                    )}
                                </HeadingBoundary>
                            </div>
                        );
                    }}
                </InView>
                <InView threshold={0.1} triggerOnce={true}>
                    {({ inView, ref, entry }) => {
                        return (
                            <div className={cx(styles['contentContainer'], (inView) && styles['inview'])} ref={ref}>
                                <HeadingBoundary>
                                    {content && (
                                        <Content
                                            className={styles['content']}
                                            content={content}
                                        />
                                    )}
                                </HeadingBoundary>
                            </div>
                        );
                    }}
                </InView>
            </Grid>
        </div>
    );
}

HeadingContent.propTypes = propTypes;
HeadingContent.defaultProps = defaultProps;

export { HeadingContent };
